module.exports = __webpack_public_path__ + "static/media/qwilt.ef210e27.png";


//////////////////
// WEBPACK FOOTER
// ./app/images/qwilt.png
// module id = 120
// module chunks = 0